import { Directive } from '@angular/core';

@Directive({ selector: '[puzzle-element]' })
export class PuzzleElementDirective {
    constructor() { }
}